import { Record } from '../components/Visit/components/Record/Record'

export const VisitRecordPage = () => {
    return <Record />
}
